// src/utils/quote/quoteStorage.js
// localStorage read/write for the anonymous draft + the activeDraftId pointer.

const DRAFT_KEY = "betonijerry.draftRequest";
const ACTIVE_ID_KEY = "betonijerry.activeDraftId";

export function readDraft() {
    try {
        const raw = localStorage.getItem(DRAFT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function writeDraft(draft) {
    try {
        // _savedAt is a forward-compat hook for timestamp-based conflict
        // resolution. Today the auto-resolve always prefers local (since the
        // conflict only happens on a device where localStorage was just used),
        // but if we ever need to compare against server.updatedAt we have the
        // local side covered.
        const stamped = { ...draft, _savedAt: Date.now() };
        localStorage.setItem(DRAFT_KEY, JSON.stringify(stamped));
    } catch {
        // quota / private mode — silently drop; backend draft still persists once auth
    }
}

export function clearDraft() {
    try { localStorage.removeItem(DRAFT_KEY); } catch { /* noop */ }
}

export function readActiveDraftId() {
    try {
        const v = localStorage.getItem(ACTIVE_ID_KEY);
        if (!v) return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
    } catch {
        return null;
    }
}

export function writeActiveDraftId(id) {
    try { localStorage.setItem(ACTIVE_ID_KEY, String(id)); } catch { /* noop */ }
}

export function clearActiveDraftId() {
    try { localStorage.removeItem(ACTIVE_ID_KEY); } catch { /* noop */ }
}
